import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnInit, Renderer, SimpleChanges, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import * as moment from 'moment';
import { Modal } from "ngx-modal";
import { environment } from "../../../environments/environment";
import { AccessLevel } from "../../common/enums/access-level.enum";
import { Permission } from "../../common/enums/permission.enum";
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { Country } from '../../shared/interface/country.interface';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { CacheService } from "../../shared/services/cache.service";
import { CommonService } from "../../shared/services/common.service";
import { MessageService } from "../../shared/services/message.service";
import { Utils } from "../../shared/Utils/utils";
import { IsoCodeThree, MemberType } from '../common/constants';
import { OrderType } from "../common/enumerations";
import { StatusConstants } from "../constants/status.constants";
import { MemberStatus, MemberStatusName } from "../enums/member-status.enum";
import { MemberTypeEnum } from "../enums/member-type.enum";
import { OrderSource, OrderSourceTypes } from "../enums/order-source.enum";
import { OrderResponse } from "../interface/order-response";
import { ProfileOrderResponse } from "../interface/profile-order-response";
import { DistributorInfo } from "../interface/ticketingsystem/distributor-info";
import { WorkTicket } from "../interface/ticketingsystem/work-ticket";
import { OrderInfoTab } from "../models/order-info-tab-model";
import { CustomerService } from "../services/customer.service";
import { OrderService } from "../services/order.service";
import { DateConstants } from '../constants/date.constants';
import { saveAs as importedSaveAs } from 'file-saver';
import { NotificationType } from '../enums/notification-types.enum';
import { TitleCasePipe } from '../../common/pipes/title-case.pipe';
import { PriceTierMemberType} from '../../customerservice/enums/price-tier.enum';


@Component({
    selector: "order-history",
    templateUrl: "../templates/template1/views/orderhistory.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/profile-info.less"
    ],
    providers: [AuthorizationPipe, CustomerService, DecimalPipe, CurrencyPipe, DatePipe, TitleCasePipe]
})
export class OrderHistoryComponent implements OnInit, OnChanges {
    @Input() fromPage: string;
    @Input() inputid: string;
    @Input() orderNumber?: string;
    @Input() webOrderNumber?: string;
    @Input() country?: string;
    @Input() homeCountryInfo: string;
    @Input() distributorInfo: DistributorInfo;
    @ViewChild('orderInput') orderInput: ElementRef;
    @ViewChild('MemberRestrictions') memberRestrictions: Modal;
    _id: string; // stores fbo id or userName
    fboOrderDetails: any;
    totalFboOrderDetails: any;
    isTitanEnabled: boolean;
    displayOrderButton: boolean;
    sortColumn: string = "orderDate";
    sort: String = "DESC";
    recentOrderSort: String = "DESC";
    sortRecentordersColumn: string = "ORD.CreatedDate";
    isRecentOrdesDesc: Boolean = true;
    pageNumber: number = 1;
    defaultPageSize: number = 25;
    pageCount: number = 0;
    recentpageCount: number = 0;
    recentpageNumber: number = 1;
    pageSizes: number[] = [10, 25, 50, 75];
    isDesc: boolean = true;
    isLoading: boolean = false;
    tickets: Array<WorkTicket> = []
    ticketsIsDesc: boolean = false;
    ticketsSort: string = "ASC";
    ticketsSortColumn: string = "ID";
    ticketsPageNumber: number = 1;
    ticketsPageSize: number = 5;
    ticketsPageCount: number = 0;
    fromDate: any;
    toDate: any;
    date: any;
    tomorrowDate: any;
    orderHistorySearchForm: FormGroup;
    memberId: number;
    shoppingCartCount = 0;
    titanEnabledCountries: Country[];
    viewShoppingBagPermission: boolean;
    orderIds = [];
    tabId: number = 1;
    webOrderId: String;
    memberStatus: any;
    storeId: number;
    storeInfo: StoreConfig;
    isGuestMemberType: boolean = false;
    exportPermission: any[] = [Permission.EXPORT_FILE_ALLOW];
    currencyDetails: any[] = [];
    isSubmitted: boolean = false;
    activetab: number = 1;
    recentOrders: any[] = [];
    pollCount = 0;
    totalRecordsPollCount = 0;
    maxPollCount = 15;
    FBORegularOrderPermissions: number[] = [
        Permission.REGULAR_ORDER_VIEW,
        Permission.REGULAR_ORDER_MANAGE,
        Permission.REGULAR_ORDER_CANCEL
    ];
    FBOPOSOrderPermissions: number[] = [
        Permission.POS_ORDER_VIEW
    ];
    FBOManageOrderPermissions: number[] = [
        Permission.REGULAR_ORDER_CREATE,
        Permission.REGULAR_ORDER_MANAGE
    ];
    FBOManagePOSOrderPermissions: number[] = [
        Permission.POS_ORDER_MANAGE,
        Permission.POS_ORDER_CREATE
    ];
    ServiceOrderViewPermission: number[] = [
        Permission.REPLACEMENT_ORDER_VIEW,
    ]
    hasCreateOrderPermissions: boolean;
    hasRegularOrderViewPermission: boolean;
    hasPOSOrderViewPermission: boolean;
    hasCreatePOSOrderPermissions: boolean;
    hasServiceOrderViewPermission: boolean;
    orderGroup = OrderType;
    showCCSnapshot: boolean;
    recentOrdersTableId: string;
    postedOrdersTableId: string;
    isRecentView = false;
    isFBOView = false;
    posRetailMemberEligibleCountries: any[]=[];
    posRetailmembrEligible :any;
    show: Boolean = true;
    showGlobal: Boolean = true;
    customerServiceAccessLevelId: number = AccessLevel.Customer_Service;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
    pdfIconUrl = environment.cdnURL + '/flpi/images/pdf_icon.png';
    printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
    enableWHLSAL00ForAsstSupervisor: boolean;
    memberType = MemberType;
    isPosOrderCreationAllowed = false;
    memberTypeEnum = MemberTypeEnum;
    displayMiddleName = false;
    constructor(private _customerservice: CustomerService, private _datePipe: DatePipe, private _commonService: CommonService, private messageService: MessageService,
        private _decimalPipe: DecimalPipe, private _formbuilder: FormBuilder, private renderer: Renderer, private _orderservice: OrderService,
        private _cacheService: CacheService, private _translateService: TranslateService, private titleCasePipe: TitleCasePipe) { }

    ngOnInit(): void {
        this.getPosMemberEligible();
        if (environment.dataLayer && environment.dataLayer.length > 0) {
            environment.dataLayer[0].pageCategory = 'orders-page';
        } 
        this.hasServiceOrderViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ServiceOrderViewPermission + "]"), AccessLevel.Customer_Service);
        this.hasCreateOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageOrderPermissions + "]"), AccessLevel.Customer_Service);
        this.hasRegularOrderViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBORegularOrderPermissions + "]"), AccessLevel.Customer_Service);
        this.hasPOSOrderViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOPOSOrderPermissions + "]"), AccessLevel.Customer_Service);
        this.hasCreatePOSOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManagePOSOrderPermissions + "]"), AccessLevel.Customer_Service);
        this.viewShoppingBagPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + Permission.VIEW_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.date = new Date();
        this.tomorrowDate =  new Date(this.date.setDate(this.date.getDate() + 1));
        this.toDate = this.momentConstructor(this.tomorrowDate);
        this.date.setMonth(this.date.getMonth() - 3);
        this.date.setDate(1);
        this.fromDate = this.momentConstructor(this.date);
        this._id = this.inputid;
        this.fboOrderDetails = new ProfileOrderResponse();
        this.totalFboOrderDetails = new ProfileOrderResponse();
        this.fboOrderDetails.orders = new Array<OrderResponse>();
        this.showCCSnapshot = true;
        this.createForm();
        this.getProfileInfo();
        //this.getAllCountriesInfo();
         this.inputid ? this.getMemberInfo() : '';
        this.recentOrdersTableId = "recentOrders#" + this._id;
        this.postedOrdersTableId = "postedOrders#" + this._id;
    }


    ngOnChanges(changes: SimpleChanges) {
        this.renderer.invokeElementMethod(this.orderInput.nativeElement, 'focus');
    }

    /** ****************** HITS SERVICES   ----- BEGIN ----- ************************* */
    /**
     * Gets fbo / retail profile detail
     */
    getProfileInfo(url?: string) {
        let orderSearchByorderNumber;
        if (this._id) {
            this.isLoading = true;
            this.setFocusToTextBox();
            let fromDateFormat;
            let toDateFormat;
            if (this.fromDate) {
                fromDateFormat = Utils.convertToSpecificDateFormat(this.fromDate, DateConstants.DateFormat);
            }
            if (this.toDate) {
                toDateFormat = Utils.convertToSpecificDateFormat(this.toDate, DateConstants.DateFormat);
            }

            this.showGlobal = true;
            this.fboOrderDetails.orders = new Array<OrderResponse>();
            orderSearchByorderNumber = this.orderHistorySearchForm.controls['orderNumber'].value;
            this._customerservice.getProfileOrderDetails(this._id, false, this.pageNumber, this.defaultPageSize, this.sort,
                this.sortColumn, this.fromPage, fromDateFormat, toDateFormat, url, orderSearchByorderNumber).subscribe(response => {
                    if (response) {
                        if (response.status === StatusConstants.COMPLETED) {
                            this.getOrderDetails(response);
                        } else {
                            this.fetchOrderDetails(response);
                        }
                    } else {
                        this.pageCount = 0;
                        this.fboOrderDetails.orders = new Array<OrderResponse>();
                    }
                    this.showGlobal = false;
                }, (error: any) => {
                    this.pageCount = 0;
                    this.fboOrderDetails.orders = new Array<OrderResponse>();
                    this.showGlobal = false;
                });
        } else {
              this.showGlobal = false;
              this.show = false;
          }
    }

    /**
     * @description
     * @date 2019-05-08
     * @param {*} response
     * @memberof OrderHistoryComponent
     */
    getOrderDetails(response: any) {
        this.pageCount = response.recordsCount ? response.recordsCount : 0;
        let orderSearchNumber = this.orderHistorySearchForm.controls['orderNumber'].value;
        if (orderSearchNumber && response.recordsCount == 1) {
            this.pageNumber = 1;
        }
        let orderIdList = [];
        this.isFBOView = false;
        this.fboOrderDetails = response;
        if (this.fboOrderDetails.orders) {
            this.fboOrderDetails.orders.forEach((orderData: any) => {
                orderData.orderDate = new Date(orderData.orderDate);
                orderIdList.push(orderData.webOrderNumber);
            });
            this.getDisputeTicketCount(orderIdList, this.fboOrderDetails.orders, true);
            const countryCodes: string[] = this.fboOrderDetails.orders.map(item => item.country);
            if (countryCodes && countryCodes.length > 0) {
                this.getStoreinfo(countryCodes, false);
            }

        } else {
            if (response.recordsCount) {
                this.pageCount = response.recordsCount;
            } else {
                this.pageCount = 0;
            }
            this.fboOrderDetails.orders = new Array<OrderResponse>();
        }
        this.isSubmitted = false;
        this.isLoading = false;
    }

    /** fetch Order details
     * @description
     * @date 2019-05-08
     * @param {*} response
     * @memberof OrderHistoryComponent
     */
    fetchOrderDetails(response: any) {
        if ((response.status === StatusConstants.IN_PROGRESS) || (response.status === StatusConstants.QUEUED)) {
            if (this.pollCount < this.maxPollCount) {
                this.pollCount = this.pollCount + 1;
                this.getProfileInfo(response.location);
            }
        }
    }
    getPosMemberEligible(){
        this._commonService.getPosMembrOrderElible().subscribe((response: any[]) => {
            if (response) {
               this.posRetailMemberEligibleCountries=response;
            }
        });
       }
    /* 
    creating dispute ticket
   */
    createTicket() {
        let viewInfo = { id: this.tabId, tabName: "Create Ticket", componentName: 'createticketpage', isDisputeTicket: true, webOrder: this.webOrderId, fboId: this.inputid };
        this.messageService.setCustomerServiceUserTabContent(viewInfo);
        this.tabId++;
    }

    /* 
     
    */
    onDatesSearch() {
        if (this.orderHistorySearchForm.valid) {
            let orderSearchNumber = this.orderHistorySearchForm.controls['orderNumber'].value;
            this.isSubmitted = true;


            if (orderSearchNumber) {
                if (this.activetab == 1) {
                    this.getRecentOrders();
                }
                else if (this.activetab == 2) {
                    this.getProfileInfo();
                }
            }
            else {
                this.recentpageCount = 0;
                this.pageCount = 0;
                this.getRecentOrders();
                this.getProfileInfo();
            }
        }
    }
    /** ************************* HITS SERVICES   ----- END ----- ************************* */
    /**
       * On Page change 
       * @param pageNumber 
       */
    pageChange(pageNumber: number) {
        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
            this.getProfileInfo();
        }
    }

    recentPageChange(recentpageNumber: number) {
        if (!isNaN(recentpageNumber)) {
            this.recentpageNumber = recentpageNumber;
            this.getRecentOrders();
        }
    }


    /**
     * sort table by respective column
     * @param sortColumn 
     */
    sortTableByColumn(sortColumn: string) {
        this.pageNumber = 1;
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : true;
        this.sort = this.isDesc ? "DESC" : "ASC";
        this.sortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.fboOrderDetails.orders.length === 0) {
            return;
        }
        this.getProfileInfo();
    }
    /* 
    form data to download to pdf/ csv/print
    */
    Download(type: string) {
        this.fetchTotalData(true, type);
    }

    /* 
    get total data without pagination
    */
    fetchTotalData(fetchAllrecords: boolean, type: string) {
        let startDate: string;
        let endDate: string;
        if (this.fromDate !== null && this.fromDate !== undefined) {
            startDate = Utils.convertToSpecificDateFormat(this.fromDate, DateConstants.DateFormat);
        }
        if (this.toDate !== null && this.toDate !== undefined) {
            endDate = Utils.convertToSpecificDateFormat(this.toDate, DateConstants.DateFormat);
        }
        if (this.activetab === 2) {
            this.getProfileOrderDetails(fetchAllrecords, type, startDate, endDate, '', this.orderNumber);
        } else {
            const sortOrder = [];
            let webOrderIdList = [];
            let recentOrdersInfo: any;
            sortOrder.push(this.sortRecentordersColumn);
            this._orderservice.getRecentOrders(this._id, 0, -1, this.recentOrderSort, sortOrder, startDate, endDate, true, this.orderNumber, true)
                .subscribe(response => {
                    if (response) {
                        if (response['content']) {
                            recentOrdersInfo = response['content'];
                        } else {
                            recentOrdersInfo = response;
                        }
                    } else {
                        recentOrdersInfo = this.recentOrders;
                    }
                    recentOrdersInfo.forEach((orderData: any) => {
                        if (orderData.source === OrderSourceTypes.CUSTOMERSERVICE) {
                            orderData.source = OrderSource.CSP;
                        } else if (orderData.source === OrderSourceTypes.WEB) {
                            orderData.source = OrderSource.WEB;
                        } else if (orderData.source === OrderSourceTypes.AUTOSHIP) {
                            orderData.source = OrderSource.AUTOSHIP;
                        } else if (orderData.source === OrderSourceTypes.AMAZON) {
                            orderData.source = OrderSource.AMAZON;
                        }
                        if (orderData && !orderData.shipToName) {
                            orderData.shipToName = (orderData.firstName ? orderData.firstName : '') + ' ' + (orderData.lastName ? orderData.lastName : '');
                            orderData.shipToName = this.titleCasePipe.transform(orderData.shipToName);
                        }
                        webOrderIdList.push(orderData.webOrderId);
                    });
                    this.getDisputeTicketCount(webOrderIdList, recentOrdersInfo, false);
                    const countryCodes: string[] = recentOrdersInfo.map(item => item.countryCode);
                    if (countryCodes && countryCodes.length > 0) {
                        this.getStoreinfo(countryCodes, true, true, type, recentOrdersInfo);
                    }
                });
        }
    }

    /**
     * @description get profile order details
     * @date 2019-05-08
     * @param {boolean} fetchAllrecords
     * @param {string} type
     * @param {string} startDate
     * @param {string} endDate
     * @memberof OrderHistoryComponent
     */
    getProfileOrderDetails(fetchAllrecords?: boolean, type?: string, startDate?: string, endDate?: string, url?: string, orderSearchByorderNumber?: String) {
        this._customerservice.getProfileOrderDetails(this._id, fetchAllrecords, 0, 0, this.sort, this.sortColumn,
            this.fromPage, startDate, endDate, url, orderSearchByorderNumber).subscribe(response => {
                if (response) {
                    if (response.status === StatusConstants.COMPLETED) {
                        this.getOrderRecords(response, type);
                    } else {
                        this.fetchOrderDetails(response);
                    }
                }
            });
    }

    /**
     * @description
     * @date 2019-05-08
     * @param {*} response
     * @param {string} type
     * @memberof OrderHistoryComponent
     */
    getOrderRecords(response: any, type: string) {
        this.totalFboOrderDetails = response;
        if (this.totalFboOrderDetails.orders) {
            let orderIds = [];
            this.totalFboOrderDetails.orders.forEach((order) => {
                orderIds.push(order.webOrderNumber);
            });
            this.getDisputeTicketCount(orderIds, this.totalFboOrderDetails.orders, true);
            const countryCodes: string[] = this.totalFboOrderDetails.orders.map(item => item.country);
            if (countryCodes && countryCodes.length > 0) {
                this.getStoreinfo(countryCodes, false, true, type);
            }
        } else {
            this.totalFboOrderDetails.orders = new Array<OrderResponse>();
        }
    }

    /** fetch Order details
     * @description
     * @date 2019-05-08
     * @param {*} response
     * @memberof OrderHistoryComponent
     */
    pendingOrderDetails(response: any) {
        if ((response.status === StatusConstants.IN_PROGRESS) || (response.status === StatusConstants.QUEUED)) {
            if (this.totalRecordsPollCount < this.maxPollCount) {
                this.totalRecordsPollCount = this.totalRecordsPollCount + 1;
                this.getProfileOrderDetails(false, '', '', '', response.location);
            }
        }
    }

    onTotalRecentOrderFetch(type: string, recentOrdersInfo): void {
        if (recentOrdersInfo) {
            var columns = [
                this._translateService.get('customer-service.Disputed')['value'],
                this._translateService.get('customer-service.Order Date')['value'],
                this._translateService.get('customer-service.Web Order')['value'] + ' #',
                this._translateService.get('customer-service.Order')['value'] + ' #',
                this._translateService.get('customer-service.Status')['value'],
                this._translateService.get('customer-service.Country')['value'],
                this._translateService.get('customer-service.Source')['value'],
                this._translateService.get('customer-service.Order Type')['value'],
                this._translateService.get('customer-service.Total')['value'],
                this._translateService.get('customer-service.Curr')['value'],
                this._translateService.get('customer-service.CC')['value'],
                this._translateService.get('customer-service.Processing Period')['value'],
                this._translateService.get('customer-service.Ship To')['value'],
            ];
            let rowdata = new Array<any>();
            let finalrows = new Array<any>();
            if (recentOrdersInfo) {
                for (let i = 0; i < recentOrdersInfo.length; i++) {
                    rowdata = [];
                    var a1 = recentOrdersInfo[i];
                    if (a1.isDisputed) {
                        rowdata.push(this._translateService.get('customer-service.Yes')['value']);
                    } else {
                        rowdata.push(this._translateService.get('customer-service.No')['value']);
                    }
                    rowdata.push(a1.storePostedDate);
                    rowdata.push(a1.webOrderId);
                    rowdata.push(a1.systemOrderNumber ? a1.systemOrderNumber : this._translateService.get('customer-service.NA')['value']);
                    rowdata.push(a1.orderStatus);
                    rowdata.push(a1.countryCode);
                    rowdata.push(a1.source);
                    rowdata.push(a1.orderTypeValue);
                    rowdata.push(a1.orderTotal);
                    rowdata.push(a1.currencyCode);
                    if (this.showCCSnapshot) {
                        rowdata.push(this._decimalPipe.transform(+(a1.orderTotalCC), '1.3-3'));

                    }
                    else {
                        rowdata.push(this._translateService.get('customer-service.NA')['value']);
                    }

                    if (a1.processedMonth !== null && a1.processedYear !== null) {
                        if (a1.processedMonth <= 9) {
                            rowdata.push('0' + a1.processedMonth + '/' + a1.processedYear);
                        } else {
                            rowdata.push(a1.processedMonth + '/' + a1.processedYear);
                        }
                    } else {
                        rowdata.push('');
                    }
                    rowdata.push(a1.shipToName);
                    finalrows.push(rowdata);
                }
            }
            let fromDateTitle: string = "";
            let toDateTitle: string = "";
            if (this.fromDate)
                fromDateTitle = Utils.convertToSpecificDateFormat(this.fromDate, DateConstants.DateFormat);

            if (this.toDate)
                toDateTitle = Utils.convertToSpecificDateFormat(this.toDate, DateConstants.DateFormat);


            const title = this._translateService.get('customer-service.FBO Order Details - From')['value'] + " : " + fromDateTitle + " - " + toDateTitle;
            if (type == "PDF")
                this._customerservice.PdfDownload(columns, finalrows, "Order Details_" + this._id, title);
            else if (type == "CSV")
                this._customerservice.ExcelDownload(columns, finalrows, "Order Details_" + this._id, title);
            else if (type = "print") {


                let table: string = "<table  style='border:solid 1px;'>";
                let thead: string = "<thead>";
                let tbody: string = "<tbody>";
                let trow: string = "";
                let totalRows: string = "";

                columns.forEach((element) => {
                    thead = thead + " <th style='border:solid 1px;  word-wrap:break-word;'> " + element + "</th>";
                });
                Object.keys(finalrows).forEach(key => {
                    trow = "<tr>";
                    for (let j = 0; j <= finalrows[key].length - 1; j++) {
                        trow = trow + "<td style='border:solid 1px;  word-wrap:break-word;'>" + finalrows[key][j] + "</td>";
                    }
                    totalRows = totalRows + trow + "</tr>";

                });

                thead = thead + "</thead>";
                tbody = tbody + totalRows + "</tbody>";

                table = table + thead + tbody + "</table>";
                this.print(table, title);
            }
        }
        else {
            this.totalFboOrderDetails.orders = new Array<OrderResponse>();
        }
    }

    onTotalFboOrderFetch(type: string): void {
        var columns = [
            this._translateService.get('customer-service.Disputed')['value'],
            this._translateService.get('customer-service.Order Date')['value'],
            this._translateService.get('customer-service.Web Order')['value'] + ' #',
            this._translateService.get('customer-service.Order')['value'] + ' #',
            this._translateService.get('customer-service.Status')['value'],
            this._translateService.get('customer-service.Country')['value'],
            this._translateService.get('customer-service.Source')['value'],
            this._translateService.get('customer-service.Order Type')['value'],
            this._translateService.get('customer-service.Total')['value'],
            this._translateService.get('customer-service.Curr')['value'],
            this._translateService.get('customer-service.CC')['value'],
            this._translateService.get('customer-service.Processing Period')['value'],
            this._translateService.get('customer-service.Ship To')['value'],
        ];
        let rowdata = new Array<any>();
        let finalrows = new Array<any>();
        if (this.totalFboOrderDetails) {
            for (let i = 0; i < this.totalFboOrderDetails.orders.length; i++) {
                rowdata = [];
                var a1 = this.totalFboOrderDetails.orders[i];
                if (a1.isDisputed) {
                    rowdata.push(this._translateService.get('customer-service.Yes')['value']);
                } else {
                    rowdata.push(this._translateService.get('customer-service.No')['value']);
                }
                rowdata.push(a1.orderDate);
                rowdata.push(a1.webOrderNumber);
                rowdata.push(a1.orderNumber);
                rowdata.push(a1.status);
                rowdata.push(a1.country);
                rowdata.push(a1.orderSource);
                rowdata.push(a1.orderType);
                rowdata.push(a1.totalAmount);
                rowdata.push(a1.currencyCode);
                if (a1.cc) {
                    rowdata.push(this._decimalPipe.transform(+(a1.cc), '1.3-3'));
                } else {
                    rowdata.push(this._translateService.get('customer-service.NA')['value']);
                }
                if (a1.processingMonth !== null && a1.processingYear !== null) {
                    if (a1.processingMonth <= 9) {
                        rowdata.push('0' + a1.processingMonth + '/' + a1.processingYear);
                    } else {
                        rowdata.push(a1.processingMonth + '/' + a1.processingYear);
                    }
                } else {
                    rowdata.push('');
                }
                rowdata.push(a1.shipToName);
                finalrows.push(rowdata);
            }
        }
        let fromDateTitle: string = "";
        let toDateTitle: string = "";
        if (this.fromDate)
            fromDateTitle = Utils.convertToSpecificDateFormat(this.fromDate, DateConstants.DateFormat);

        if (this.toDate)
            toDateTitle = Utils.convertToSpecificDateFormat(this.toDate, DateConstants.DateFormat);

        const title = this._translateService.get('customer-service.FBO Order Details - From')['value'] + " : " + fromDateTitle + " - " + toDateTitle;
        if (type == "PDF")
            this._customerservice.PdfDownload(columns, finalrows, "Order Details_" + this._id, title);
        else if (type == "CSV")
            this._customerservice.ExcelDownload(columns, finalrows, "Order Details_" + this._id, title);
        else if (type = "print") {
            let table: string = "<table  style='border:solid 1px;'>";
            let thead: string = "<thead>";
            let tbody: string = "<tbody>";
            let trow: string = "";
            let totalRows: string = "";

            columns.forEach((element) => {
                thead = thead + " <th style='border:solid 1px;  word-wrap:break-word;'> " + element + "</th>";
            });
            Object.keys(finalrows).forEach(key => {
                trow = "<tr>";
                for (let j = 0; j <= finalrows[key].length - 1; j++) {
                    trow = trow + "<td style='border:solid 1px;  word-wrap:break-word;'>" + finalrows[key][j] + "</td>";
                }
                totalRows = totalRows + trow + "</tr>";

            });

            thead = thead + "</thead>";
            tbody = tbody + totalRows + "</tbody>";

            table = table + thead + tbody + "</table>";
            this.print(table, title);
        }
    }

    /* 
     Print whole data
    */

    print(data: any, title: string) {
        var printWindow = window.open('', '', 'height=400,width=800');
        printWindow.document.write('<html><head><title>' + title + '</title>');
        printWindow.document.write('</head><body >');
        printWindow.document.write(data);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();

    }
    onDateChange(date: any, valueToChange: string): any {
        if (valueToChange === 'fromDate') {
            this.fromDate = date;
        } else if (valueToChange === 'toDate') {
            this.toDate = date;
        }
    }
    onDateClear(valueToClear: string): void {
        if (valueToClear === 'fromDate') {
            this.fromDate = '';
        } else if (valueToClear === 'toDate') {
            this.toDate = '';
        }
    }

    clearFields() {
        this.fromDate = '';
        this.toDate = '';
        this.orderNumber = '';
        this.renderer.invokeElementMethod(this.orderInput.nativeElement, 'focus');
    }
    /*
    get Dispute Tickets created on selected web order Id.
     */
    getDisputeTickets() {
        this._customerservice.SearchTicketsOnPagination((this._id), null, null, null, null, null, null, null, null, this.ticketsPageNumber, this.ticketsPageSize, this.ticketsSortColumn, this.ticketsSort, this.webOrderId).subscribe((response: WorkTicket[]) => {
            if (response) {

                this.tickets = response["content"];
                this.ticketsPageCount = response["totalCount"];
            } else {
                this.tickets = [];
                this.ticketsPageCount = 0
            }
        });
    }
    /*
    view or edit Dispute tickets in new tab
     */
    goToViewTicket(idt: any, ticketNumber: any, isView: boolean) {
        let viewInfo = { id: ticketNumber, ticketId: idt, isView: isView, tabName: "Ticket-" + ticketNumber, componentName: 'viewfboticketpage' };
        this.messageService.setCustomerServiceUserTabContent(viewInfo);
    }
    /*
    sort dispute tickets by column
     */
    sortTicketsByColumn(sortColumn: string) {
        this.ticketsIsDesc = (this.ticketsSortColumn == sortColumn) ? !this.ticketsIsDesc : this.ticketsIsDesc;
        this.ticketsSort = this.ticketsIsDesc ? "DESC" : "ASC";
        this.ticketsSortColumn = sortColumn;
        // added this condition not to hit service if there are no items in grid.
        if (this.tickets.length === 0) {
            return;
        }
        this.getDisputeTickets();
    }

    getStoreinfo(countryCodes: string[], recentOrderStores: boolean, isExport?: boolean, type?: string, recentOrdersInfo?: any) {
        countryCodes = countryCodes.filter(function (item, pos) {
            return countryCodes.indexOf(item) === pos;
        })
        this._customerservice.getStoreInfo(countryCodes).subscribe((data: any) => {
            if (data && data.length > 0) {
                this.currencyDetails = data;
                if (!recentOrderStores && !isExport) {
                    this.fboOrderDetails.orders.forEach((orderData: any) => {
                        const store = this.currencyDetails.find(item => item.homeCountryCode === orderData.country);
                        orderData.totalAmount = this._commonService.getCurrencyFormat(store, store.currencyFormatCode, orderData.totalAmount);
                        orderData.currencyCode = store.currencyCode;
                        orderData.orderTypeValue = orderData.orderType;
                        if(orderData.orderType && orderData.orderType == PriceTierMemberType.FBO + ' 0%'){
                            orderData.orderType = PriceTierMemberType.FBO;
                        }
                        orderData.orderDate = moment(orderData.orderDate).format('DD-MMM-YYYY');
                        orderData.orderPostedDate = orderData.orderPostedDate ?
                            moment(orderData.orderPostedDate).format('DD-MMM-YYYY') : moment(orderData.orderDate).format('DD-MMM-YYYY');
                    });
                    this.isFBOView = true;
                } else if (recentOrderStores && !isExport) {
                    this.recentOrders.forEach((orderData: any) => {
                        const store = this.currencyDetails.find(item => item.homeCountryCode === orderData.countryCode);
                        orderData.orderTotal = this._commonService.getCurrencyFormat(store, store.currencyFormatCode, orderData.orderTotal);
                        orderData.currencyCode = store.currencyCode;
                        this.enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(orderData.countryCode);
                        const isServiceOrder = (orderData && orderData.orderTypeId === OrderType.SERVICE_ORDER) ? true : false;
                        orderData.orderTypeValue =
                            this._commonService.getDiscountPriceLevel(orderData.priceTierID, orderData.memberLevelDiscount,
                                orderData.memberTypeId, this.enableWHLSAL00ForAsstSupervisor, isServiceOrder);
                        const timeZoneOffset = store && store.timeZoneOffset.toString() ? store.timeZoneOffset : -6;
                        orderData.createdDate = moment(orderData.createdDate).utcOffset(timeZoneOffset).format('DD-MMM-YYYY');
                        orderData.orderPostedDate = moment.utc(orderData.orderPostedDate).utcOffset(timeZoneOffset).format('DD-MMM-YYYY');
                        if(orderData.storePostedDate){
                            orderData.storePostedDate = moment.utc(orderData.storePostedDate).format('DD-MMM-YYYY');
                        }
                    });
                    this.isRecentView = true;
                } else if (!recentOrderStores && isExport) {
                    this.totalFboOrderDetails.orders.forEach((orderData: any) => {
                        const store = this.currencyDetails.find(item => item.homeCountryCode === orderData.country);
                        orderData.orderDate = moment(orderData.orderDate).format('DD-MMM-YYYY');
                        orderData.orderPostedDate = orderData.orderPostedDate ?
                            moment(orderData.orderPostedDate).format('DD-MMM-YYYY') : moment(orderData.orderDate).format('DD-MMM-YYYY');
                        orderData.totalAmount = this._commonService.getCurrencyFormat(store, store.currencyFormatCode, orderData.totalAmount);
                        orderData.currencyCode = store.currencyCode;
                        orderData.orderTypeValue = orderData.orderType;                        
                    });
                    this.onTotalFboOrderFetch(type);
                } else if (recentOrderStores && isExport) {
                    recentOrdersInfo.forEach((orderData: any) => {
                        const store = this.currencyDetails.find(item => item.homeCountryCode === orderData.countryCode);
                        const timeZoneOffset = store && store.timeZoneOffset ? store.timeZoneOffset : -6;
                        orderData.createdDate = orderData.orderPlacedDate;
                        orderData.createdDate = moment(orderData.createdDate).utcOffset(timeZoneOffset).format('DD-MMM-YYYY');
                        orderData.orderPostedDate = moment.utc(orderData.orderPostedDate).utcOffset(timeZoneOffset).format('DD-MMM-YYYY');
                        if(orderData.storePostedDate){
                            orderData.storePostedDate = moment.utc(orderData.storePostedDate).format('DD-MMM-YYYY');
                        }
                        orderData.orderTotal = this._commonService.getCurrencyFormat(store, store.currencyFormatCode, orderData.orderTotal);
                        orderData.currencyCode = store.currencyCode;
                        this.enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(orderData.countryCode);
                        const isServiceOrder = (orderData && orderData.orderTypeId === OrderType.SERVICE_ORDER) ? true : false;
                        orderData.orderTypeValue =
                            this._commonService.getDiscountPriceLevel(orderData.priceTierID, orderData.memberLevelDiscount,
                                orderData.memberTypeId, this.enableWHLSAL00ForAsstSupervisor, isServiceOrder);
                    });
                    this.onTotalRecentOrderFetch(type, recentOrdersInfo);
                }
            }
            if (this.homeCountryInfo !== "" && this.distributorInfo) {
                let homeCountry = [this.homeCountryInfo];
                this._customerservice.getStoreInfoFromConfig(homeCountry)
                    .subscribe(response => {
                        if (response) {
                            this.storeId = response.countryId;
                            this.storeInfo = response;
                            if (this.recentOrders && this.recentOrders.length){
                            this.recentOrders.forEach(x=> { 
                            const shipToName = (x.firstName ? x.firstName + ' ': '') +
                            (this.storeInfo.displayMiddleName && x.middleName ? x.middleName + ' ' : '') +
                                (x.lastName ? x.lastName : '') 
                                x.shipToName = shipToName ? shipToName : x.shipToName;
                                x.shipToName = this.titleCasePipe.transform(x.shipToName);
                            });
                            this.displayMiddleName =  true;
                        }
                    }
                    });
            }
        });

    }

    /**
    * @description This method used to get disputed ticket count by webOrderId
    * 
    * @returns void
    */
    getDisputeTicketCount(orderIdList: string[], responseData: any, isFboDetails: boolean) {
        const disputeTicketCountModel = {
            "orderIds": orderIdList
        };
        this._customerservice.getDisputeTicketCountByOrderIds(disputeTicketCountModel).subscribe(response => {
            if (isFboDetails) {
                responseData.forEach((order) => {
                    order.isDisputed = response && response.find(item => item.orderid === order.webOrderNumber);
                });
            } else {
                responseData.forEach((order) => {
                    order.isDisputed = response && response.find(item => item.orderid === order.webOrderId);
                });
            }
        });
    }

    openOrderViewTab(isSystemOrderNumberClick: boolean = false, orderNumber: string, webOrderNumber: string, country: string, recentOrder: boolean, retailId?: string, orderDate?: string, orderPostedDate?: string, backDateOrder?: boolean, systemOrderNumber?: string, isFBOView?: boolean) {
        const orderInfo = new OrderInfoTab();
        orderInfo.webOrderID = webOrderNumber;
        orderInfo.orderID = orderNumber;
        orderInfo.homeCountry = country;
        orderInfo.distributorID = this.inputid;
        orderInfo.retailID = retailId;
        orderInfo.recentOrder = recentOrder;
        let scandinavianCountries = this.getScandinavianCountries();
        let beneluxCountries = this.getBeneluxCountries();
        let deuCountries = this.getDeuCountries();
        let fileName = this.distributorInfo.distributorId + '_' + systemOrderNumber + '.pdf';
        if (deuCountries.includes(country)) {
            const orderDate1 = backDateOrder ? (isFBOView ? new Date(orderPostedDate) : '') : (isFBOView ? new Date(orderDate) : new Date(orderDate));
            const goLiveDate = new Date(environment.deuGoLiveDate);
            if (orderDate1 < goLiveDate) {
                this._orderservice.downloadOrderInvoice(this.distributorInfo.distributorId, systemOrderNumber, country).subscribe(blob => {
                    if (blob && blob.size === 0) {
                        const notification: any = this._translateService.get('orderdetails.Order Not Found');
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    } else {
                        importedSaveAs(blob, fileName);
                    }
                },
                    error => {
                        console.log(error);
                    });
            } else {
                this.messageService.setOrderHistoryTab(orderInfo);
            }
        } else if (scandinavianCountries.includes(country)) {
            const orderDate1 = backDateOrder ? (isFBOView ? new Date(orderPostedDate) : '') : (isFBOView ? new Date(orderDate) : new Date(orderDate));
            const goLiveDate = new Date(environment.scanGoLiveDate);
            if (orderDate1 < goLiveDate) {
                this._orderservice.download(this.distributorInfo.distributorId, systemOrderNumber).subscribe(blob => {
                    if (blob && blob.size === 0) {
                        const notification: any = this._translateService.get('orderdetails.Order Not Found');
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    } else {
                        importedSaveAs(blob, fileName);
                    }
                },
                    error => {
                        console.log(error);
                    });
            } else {
                this.messageService.setOrderHistoryTab(orderInfo);
            }
        } else if (beneluxCountries.includes(country)) {
            if (isSystemOrderNumberClick && systemOrderNumber) {
                this._orderservice.downloadOrderInvoice(this.distributorInfo.distributorId, systemOrderNumber, country).subscribe(blob => {
                    if (blob && blob.size === 0) {
                        this.messageService.setOrderHistoryTab(orderInfo);
                    } else {
                        importedSaveAs(blob, fileName);
                    }
                },
                    error => {
                        console.log(error);
                    });
            } else {
                this.messageService.setOrderHistoryTab(orderInfo);
            }
        } else {
            this.messageService.setOrderHistoryTab(orderInfo);
        }
    }

    createForm() {
        this.orderHistorySearchForm = this._formbuilder.group(
            {
                fromDate: ['', [Validators.required, Utils.validateFromDate()]],
                toDate: ['', [Utils.validateToDate()]],
                orderNumber: ['']
            });
    }
    checkValidationForToDate() {
        this.orderHistorySearchForm.controls['toDate'].updateValueAndValidity();
    }
    checkValidationForFromDate() {
        this.orderHistorySearchForm.controls['fromDate'].updateValueAndValidity();
    }

    setFocusToTextBox() {
        setTimeout(function () {
            const orderInputElement = document.getElementById('orderInput');
            if (orderInputElement) {
                orderInputElement.focus();
            }

        }, 1000);
    }

    OnTabEventRecentlyViewed() {
        const orderInputElement = document.getElementById('orderInput');
        if (orderInputElement) {
            orderInputElement.focus();
        }
    }

    onToDateFocus() {
        const toDateElement = document.getElementById('toDate');
        if (toDateElement) {
            toDateElement.focus();
        }
        this.onDatesSearch();
    }
    /**
     * select tabs
     */
    selectTab(tab: any) {
        this.activetab = tab;
    }

    /**
     * get member Info
     */
    getMemberInfo() {
        this._customerservice.getMemberDetails(this.inputid).subscribe(response => {
            if (response && response.memberId) {
             let homeCountry :any = response.homeCompany;
             let posMemberConfig :any;
             if(this.posRetailMemberEligibleCountries){
                posMemberConfig  = this.posRetailMemberEligibleCountries.find(x=>x.countryCode===homeCountry.toUpperCase());
             }
           
                this.isTitanEnabled = response.isSuccess;
                this.memberId = response.memberId;
                this.memberStatus = response.memberStatus;
                this.getRecentOrders();
                this.isPosOrderCreationAllowed = !(response.memberTypeId === MemberTypeEnum.GUEST ||
                    response.memberTypeId === MemberTypeEnum.RETAIL);
                if(posMemberConfig && posMemberConfig.enablePosOrderForRetail &&  response.memberTypeId === MemberTypeEnum.RETAIL){
                        this.isPosOrderCreationAllowed =true;
                }

            } else {
                this.show = false;
            }
            this.displayOrderButton = true;
        }, error => {
            this.displayOrderButton = true;
        });
    }
    /**
    * to get recent orders that are in titan
    */
    getRecentOrders() {
        if (this._id) {
            const sortOrder = [];
            let fromDateFormat;
            let toDateFormat;
            let orderSearchByorderNumber;
            sortOrder.push(this.sortRecentordersColumn);
            if (this.fromDate) {
                fromDateFormat = Utils.convertToSpecificDateFormat(this.fromDate, DateConstants.DateFormat);
            }
            if (this.toDate) {
                toDateFormat = Utils.convertToSpecificDateFormat(this.toDate, DateConstants.DateFormat);
            }

            this.show = true;
            orderSearchByorderNumber = this.orderHistorySearchForm.controls['orderNumber'].value;
            this.recentOrders = new Array<OrderResponse>();
            this._orderservice.getRecentOrders(this._id, this.recentpageNumber, this.defaultPageSize,
                this.recentOrderSort, sortOrder, fromDateFormat, toDateFormat, true, orderSearchByorderNumber, true).subscribe(response => {
                    if (response) {
                        if (response['content']) {                     
                            response.totalCount ? this.recentpageCount = response.totalCount : '';
                            this.recentOrders = response['content'];
                        }
                        else {
                            this.recentpageCount = 1;
                            this.recentpageNumber = 1;
                            this.recentOrders.push(response[0]);
                        }
                        this.isRecentView = false;
                        this.recentOrders.forEach((order: any) => {
                            order.createdDate = order.orderPlacedDate;
                            this.orderIds.push(order.webOrderId);
                        });
                        this.getDisputeTicketCount(this.orderIds, this.recentOrders, false);
                        this.recentOrders.forEach((orderData: any) => {
                            if (orderData.source === OrderSourceTypes.CUSTOMERSERVICE) {
                                orderData.source = OrderSource.CSP;
                            } else if (orderData.source === OrderSourceTypes.WEB) {
                                orderData.source = OrderSource.WEB;
                            } else if (orderData.source === OrderSourceTypes.AUTOSHIP) {
                                orderData.source = OrderSource.AUTOSHIP;
                            } else if (orderData.source === OrderSourceTypes.AMAZON) {
                                orderData.source = OrderSource.AMAZON;
                            }
                        });
                        const countryCodes: string[] = this.recentOrders.map(item => item.countryCode);
                        if (countryCodes && countryCodes.length > 0) {
                            this.getStoreinfo(countryCodes, true);
                        }
                    }
                    else {
                        this.recentpageCount = 0;
                        this.recentOrders = new Array<OrderResponse>();
                    }
                    this.show = false;
                });
        }
    }

    orderHistoryTransformDate(date: any, isStartDate: boolean) {

        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DateFormat);
        if (dateMomentObj) {
            if (isStartDate) {
                if (this.orderHistorySearchForm.controls['fromDate'].valid) {
                    this.orderHistorySearchForm.controls['fromDate'].setValue(moment(dateMomentObj, 'DD-MMM-YYYY'));
                }
            }
            else if (this.orderHistorySearchForm.controls['toDate'].valid) {
                this.orderHistorySearchForm.controls['toDate'].setValue(moment(dateMomentObj, 'DD-MMM-YYYY'));
            }
        }
    }

    /**
     * to sort recent orders
     */

    sortRecentOrdersByColumn(sortColumn: string) {
        this.recentpageNumber = 1;
        this.isRecentOrdesDesc = (this.sortRecentordersColumn == sortColumn) ? !this.isRecentOrdesDesc : true;
        this.recentOrderSort = this.isRecentOrdesDesc ? 'DESC' : 'ASC';
        this.sortRecentordersColumn = sortColumn;
        // added this condition not to hit service if there are no items in grid.
        if (this.recentOrders.length === 0) {
            return;
        }
        this.getRecentOrders();
    }

    getAllCountriesInfo() {
        this._customerservice.getAllCountries(true).subscribe(response => {
            if (response) {
                this.titanEnabledCountries = response.filter(country => country.titanPlatformEnabled);
            }
        });
    }
    /**
     * recent orders table page change event
     */
    createNewOrder() {
        if ((!this.isTitanEnabled) || this.memberStatus && (this.memberStatus.id === +MemberStatus.Active)) {
            const CreateOrderInfo = {
                distributorId: this.inputid
            };
            this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, CreateOrderInfo);
            window.open(window.location.origin + "/customerservice/orders", '_blank');
        }
        else {
            this.memberRestrictions.open();
            return false;
        }
    }

    /**
     * Recent POS orders table page change event
     */
    createNewPOSOrder() {
        if ((!this.isTitanEnabled) || this.memberStatus && (this.memberStatus.id === +MemberStatus.Active)) {
            const CreatePOSOrderInfo = {
                distributorId: this.inputid
            };
            this._cacheService.set(CacheKey.CREATE_POS_ORDER_INFO_SESSION_CODE, CreatePOSOrderInfo);
            window.open(window.location.origin + "/customerservice/posorders", '_blank');
        } else {
            this.memberRestrictions.open();
            return false;
        }
    }

    closePopup = () => {
        this.memberRestrictions.close();
    }

    /**
     * @description to select the no of records to be displayed
     * @date 2020-03-12
     * @param {number} pageSize
     * @memberof OrderHistoryComponent
     */
    pageSizeChange(pageSize: number): void {
        if (!isNaN(pageSize)) {
            this.pageNumber = 1;
            this.recentpageNumber = 1;
            this.defaultPageSize = pageSize;
            this.getRecentOrders();
            this.getProfileInfo();
        }
    }

    getScandinavianCountries() {
        let scandinavianCountries: Array<string> = [];
        if (environment.scandinavianCountries !== undefined && environment.scandinavianCountries !== null
            && environment.scandinavianCountries !== '') {
            scandinavianCountries = environment.scandinavianCountries.toUpperCase().split(',');
        }
        return scandinavianCountries;
    }

    getBeneluxCountries() {
        let beneluxCountries: Array<string> = [];
        if (environment.beneluxCountries !== undefined && environment.beneluxCountries !== null
            && environment.beneluxCountries !== '') {
                beneluxCountries = environment.beneluxCountries.toUpperCase().split(',');
        }
        return beneluxCountries;
    }

    getDeuCountries() {
        if (environment.deuCountries) {
            return environment.deuCountries.toUpperCase().split(',');
        }
        return [];
    }
  
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/orderhistory.component.ts